import React from "react";
import { CircularProgress } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
const DeletePopup = ({ onClose, onConfirm, Name, buttonloading, message }) => {
  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show d-block"
        id="customerModal"
        aria-modal="true"
        role="dialog"
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-md modal-dialog-scrollable "
          onClick={stopPropagation}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="modal-content border-0 radius-30 "            
          >
            <div className="modal-body text-center bg-white">
              <div className="d-flex justify-content-center align-item-center">
                <WarningIcon className="font-70"sx={{ color: "#ffc107" }} />
              </div>
              <h5 className="mt-3 text-danger ">Delete {Name}</h5>
              <p>
                {" "}
                {message &&
                  message.split("<br>").map((line, index) => (
                    <span key={index}>
                      {line}
                      <br />
                    </span>
                  ))}
              </p>

              <div className="d-flex justify-content-center mb-2 mt-4">
                {buttonloading ? (
                  <button className="btn btn-danger pb-0 text-center" disable>
                    <CircularProgress size={22} className="text-white" />
                  </button>
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={onConfirm}
                      className="btn btn-danger text-left me-3"
                    >
                      <i className="bx bx-trash font-20"></i> Delete
                    </button>
                  </>
                )}
                <button
                  type="button"
                  onClick={onClose}
                  className="btn btn-outline-secondary pull-right "
                >
                  <i className="bx bx-x font-20"></i> Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
